// LIBS
import React from 'react'

// INTERFACE
const FilterCheckbox = ({ title, checked, category, value, onChange, isDisabled = false }) =>
  <div>
    <input
      id={`${category}_${value}`}
      name={category}
      value={value}
      checked={checked}
      onChange={onChange}
      type="checkbox"
      disabled={isDisabled ? true : false}
    />
    <label htmlFor={`${category}_${value}`} style={isDisabled ? {opacity:0.5} : {}}>{title}</label>
  </div>

export default FilterCheckbox



// WEBPACK FOOTER //
// ./src/components/filter-checkbox/index.js